import React from 'react';

import Stack from '@mui/material/Stack';
import DialogTitle from '@mui/material/DialogTitle';

import CloseIcon from 'ff/debrief/components/customIcons/CloseIcon';

interface Props {
    onClose: () => void;
}

const DebriefDialogTitle = (props: React.PropsWithChildren<Props>) => {
    return (
        <DialogTitle>
            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
            >
                <span>{props.children}</span>
                <CloseIcon
                    onClick={props.onClose}
                    sx={{
                        transition: 'color 0.3s ease',
                        color: '#FFFFFF',
                        ':hover': {
                            transition: 'color 0.3s ease',
                            color: '#FFFFFF',
                            cursor: 'pointer',
                        },
                    }}
                />
            </Stack>
        </DialogTitle>
    );
};

export default DebriefDialogTitle;
